export default function (price) {
  if (!price || !price.amount || !price.currency) {
    return ' - '
  }
  let prefix = price.currency

  switch (price.currency) {
  case 'USD':
  case 'CAD':
  case 'NZD':
  case 'AUD':
    prefix = '$'
    break
  case 'ZAR':
    prefix = 'R'
    break
  case 'EUR':
    prefix = '€'
    break
  case 'GBP':
    prefix = '£'
    break
  }
  const fixed = price.amount - Math.floor(price.amount) === 0 ? 0 : 2
  const separateThousands = /(\d)(?=(\d{3})+(?!\d))/g
  return `${prefix} ${price.amount.toFixed(fixed).replace(separateThousands, '$1,')}`
}
